import { Pipe, PipeTransform } from '@angular/core'
import { RootCauseAnalysisService } from '../services/fault-analysis/root-cause-analysis.service'
import { catchError, Observable, of } from 'rxjs'

@Pipe({
  name: 'secureImage',
  standalone: false,
})
export class SecureImagePipe implements PipeTransform {
  constructor(private service: RootCauseAnalysisService) {}

  transform(photo: any): any {
    // return this.service.getTagPhoto(photo.id, photo.tag, photo.no).pipe(
    //   switchMap(blob => {
    //     // return new observable which emits a base64 string when blob is converted to base64
    //     return new Observable(observer => {
    //       const reader = new FileReader()
    //       reader.readAsDataURL(blob) // convert blob to base64
    //       reader.onloadend = () => {
    //         return observer.next(reader.result) // emit the base64 string result
    //       }
    //     })
    //   }),
    // )

    return new Observable<string>((observer) => {
      // This is a tiny blank image
      const blankImage =
        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      observer.next(blankImage)
      // The next and error callbacks from the observer
      const thumb = !!photo.thumb
      this.service
        .getTagPhotoBase64(photo.id, photo.tag, photo.no, thumb)
        .pipe(
          catchError((err) => {
            return of(blankImage)
          }),
        )
        .subscribe((response) => {
          observer.next(`data:${response.mime};base64,${response.base64}`)
        })
      return { unsubscribe() {} }
    })
  }
}
